export default class PasswordReset {
	active: boolean;

	constructor(active: boolean) {
		this.active = active;
	}
}
